<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Transporter Approve</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
              @change="getInstallmentData()"
            />
          </v-col>
          <!-- <v-col cols="12" sm="2">
                    <p><b>Standard</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="standard"  :items="standard_list" item-text="standard" item-value="id" label="Standard" outlined persistent-hint hint="Please Select Standard"/>
                </v-col> -->
          <v-col cols="12" sm="2">
            <p><b>Approval Status</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="transport_status"
              :items="transport_status_list"
              item-text="status"
              item-value="id"
              label="Transport Approval Status"
              outlined
              persistent-hint
              hint="Please Select Status"
            />
          </v-col>
          <v-col cols="12" sm="2" v-if="transport_installment_list!=''">
            <p><b>Installment</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="transport_installment"
              :items="transport_installment_list"
              item-text="name"
              item-value="id"
              label="Transport Installment"
              outlined
              persistent-hint
              hint="Please Select Installment"
            />
          </v-col>
          <v-col cols="12" sm="3" v-if="all_learner_list!=''">
            <p><b>Learner</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="learner"
              :items="all_learner_list"
              item-text="learner"
              item-value="id"
              label="Student"
              outlined
              persistent-hint
              hint="Please Select Student"
            />
          </v-col>
        </v-row>
        <!-- //v-if="this.transport_installment && this.transport_status && this.learner"> -->
        <v-row justify="center" dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col col="12" sm="4" md="4">
            <v-btn color="warning" @click="fetch()">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <!-- {{tranport_fee_sync}} -->

      <span v-if="!tranport_fee_sync == true">
      <v-card
        class="box"
        v-if="learner_transport_fees_installment_details.length > 0"
      >
        <v-data-table :headers="headers" :items="learner_transport_fees_installment_details" :search="search">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-toolbar>
          </template> 
          <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.is_blocked_for_transport==false">
              <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="green"
                  @click="editItem(item)"
                  >mdi-application-export</v-icon
                >
              </v-avatar>
            </div>
             <div v-else>
              <b>Student Is Blocked For Transport...</b>
            </div>
          </template>
          <template v-slot:[`item.history`]="{ item }">
            <div>
              <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="red"
                  @click="getArrovalHistory(item)"
                  >mdi-eye</v-icon
                >
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </v-card>
      </span>
      <span v-else>
 <v-card
        class="box"
        v-if="learner_transport_fees_installment_details.length > 0"
      >
        <v-data-table :headers="headers_2" :items="sortedTransportList" :search="search">
          <template v-slot:top>
             <v-row>
                    <v-btn rounded color="success" outlined class="ml-4 mb-2" 
                        @click="downloadFile()" :loading="loader"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
              </v-row>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-toolbar>
          </template> 
            <template v-slot:item.srno="{ item }">
              {{ sortedTransportList.indexOf(item) + 1 }}
            </template>
          <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.is_blocked_for_transport==false && item.is_transport_sync==false">
              <v-btn color="warning" @click="markApprove(item)">Approve</v-btn>
              <!-- <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="green"
                  @click="markApprove(item)"
                  >mdi-account-check</v-icon
                >
              </v-avatar> -->
            </div>
             <div v-else-if="item.is_transport_sync==true">
               <b>Already Synched...</b>
             </div>
             <div v-else>
              <b>Student Is Blocked For Transport...</b>
            </div>
          </template>
          <!-- <template v-slot:[`item.unmark`]="{ item }">
            <div v-if="item.is_blocked_for_transport==false && item.is_transport_sync==true">
              <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="red"
                  @click="markApprove(item)"
                  >mdi-account-cancel</v-icon
                >
              </v-avatar>
            </div>
            <div v-else-if="item.is_transport_sync==false ">
               <b>Not Synched Yet...</b>
             </div>
             <div v-else-if="item.is_blocked_for_transport==true">
              <b>Student Is Blocked For Transport...</b>
            </div>
          </template> -->
        </v-data-table>
      </v-card>


      </span>

      <v-dialog v-model="show_approve_transport_card" fullscreen>
        <v-card>
          <v-toolbar class="toolbar no-display" flat dense>
            <v-btn icon dark @click="show_approve_transport_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <strong> Details </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>PRN</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.registration_number"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Student Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.learner"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Standard</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.standard"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Pick Up Time</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.pickup_time"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Drop Time</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.drop_time"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>Route Stop</b></p>
                 <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.routestop_name"
                  readonly
                ></v-text-field>
                <!-- <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="routestop"
                  :items="route_stops"
                  item-text="name"
                  item-value="id"
                  label="Route Stop"
                  outlined
                  persistent-hint
                  hint="Please Select Route Stop"
                  readonly
                /> -->
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Route</b></p>
                 <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.route_name"
                  readonly
                ></v-text-field>
                <!-- <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="route"
                  :items="routes"
                  item-text="name"
                  item-value="id"
                  label="Route"
                  outlined
                  persistent-hint
                  readonly
                /> -->
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Distance Slab in KM</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.distanceslab"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Total Fees In Rs.</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.applicable_fees"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Current Installment Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.transport_installment"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- {{isLastAuthority}} -->
            <!-- {{{{isLastAuthority}}}} -->
            <v-row justify="center" dense>
              <v-col cols="12" sm="2"  v-if="isLastAuthority">
                <p><b>Change Installment and amount</b></p>
                <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="transportinstallment"
                  :items="transport_installment_list"
                  item-text="name"
                  item-value="id"
                  @change="setValue(transportinstallment)"
                  label="Installment"
                  hint="Editable"
                  outlined
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" sm="2" v-if="totalfees_approved != ''">
                <p><b>Total Fees Applicable In Rs.</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="totalfees_approved"
                ></v-text-field>
              </v-col> 
              <v-col cols="12" sm="2">
                <p><b>Action</b></p>
                <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="transportstatus"
                  :items="transport_status_list"
                  item-text="status"
                  item-value="id"
                  label="Status"
                   hint="Select Your Approval"
                  outlined
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Remark</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="approve_remark"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense v-if="transportstatus"> 
              <v-btn color="warning" @click="saveApproveStatus()">Save</v-btn>
            </v-row>
          </v-card>
        </v-card>
      </v-dialog>
      <v-dialog v-model="show_approve_history_card" fullscreen>
        <v-card>
          <v-toolbar class="toolbar no-display" flat dense>
            <v-btn icon dark @click="show_approve_history_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <strong> Transport Approval History </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>PRN</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.registration_number"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Student Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.learner"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Standard</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.standard"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Pick Up Time</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.pickup_time"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Drop Time</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.drop_time"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>Route Stop</b></p>
                <!-- <br /> -->
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.routestop"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Route</b></p>
                <!-- <br /> -->
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.route"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Distance Slab in KM</b></p>
                <!-- <br /> -->
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.distanceslab"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Total Fees Applicable In Rs.</b></p>
                <!-- <br /> -->
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.totalfees"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Installment</b></p>
                <!-- <br /> -->
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.transport_installment"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Installment Fees Applicable In Rs</b></p>
                 <!-- <br /> -->
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="
                    transportApplicationsDetails.transport_installment_amount
                  "
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="box" v-if="transportApprovalDetails.length > 0">
            <v-data-table
              :headers="headers_history"
              :items="transportApprovalDetails"
            >
              <template v-slot:top>
                <v-toolbar flat class="toolbar">
                  <v-toolbar-title>Transport Approval History</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:[`item.is_last_approval`]="{ item }">
                <span v-if="item.is_last_approval">
                  <v-icon class="mr-2 v-icon-size" color="success"
                    >mdi-check-circle-outline</v-icon
                  >
                </span>
                <span v-else>
                  <v-icon class="mr-2 v-icon-size" color="error"
                    >mdi-close-circle-outline</v-icon
                  >
                </span>
              </template>
            </v-data-table>
          </v-card>
          <v-card v-else>
            <br>
            <v-row justify="center">
             <strong color="red">No action taken yet...</strong>
            </v-row>

          </v-card>
         
        </v-card>
        
      </v-dialog>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import * as XLSX from "xlsx";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    search: "",
    is_final_approved:false,
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [],
    ay: "",
    standard_list: [],
    standard: "",
    transport_status_list: [],
    transport_status: "",
    transport_installment_list: [],
    transport_installment: "",
    all_learner_list: [],
    learner: "",
    learner_transport_fees_installment_details: [],
    show_approve_transport_card: false,
    child_details: {
      lid: "",
      registration_number: "",
      learner: "",
      standard: "",
      pickup_time: "",
      drop_time: "",
      academicYear: "",
      contact: "",
      resedential_address: "",
      totalfees: "",
      paid_till_now: "",
      applicable_fees: "",
      routestop: "",
      route: "",
      distanceslab: "",
      transport_installment_amount: "",
      transport_installment: "",
      routestop_name: "",
      route_name: "",
    },
    totalfees_approved: "",
    route_stops: [],
    routestop: "",
    routes: [],
    route: "",
    transport_installment_list: [],
    transportinstallment: "",
    transport_status_list: [],
    transportstatus: "",
    approve_remark: "",
    learnertransportfeesinstallment: "",
    transportApprovalDetails: [],
    show_approve_history_card: false,
    transportApplicationsDetails: [],
    learner_transport_fees_installment_id: "",
    headers: [
      { text: "SR No", value: "srno" },
      { text: "PRN", value: "prn" },
      { text: "Student", value: "name" },
      { text: "Route Stop", value: "route_stop" },
      { text: "Installment", value: "transportinstallment" },
      { text: "Fees In Rs", value: "amount" },
      { text: "Paid Till Now", value: "paid_till_now" },
      { text: "Your Approval Status", value: "your_status" },
      { text: "Final Approval Status", value: "transportapprovalstatus" },
      { text: "Action", value: "action" },
      { text: "My Approval Status", value: "history" },
    ],
      headers_2: [
      { text: "SR No", value: "srno" },
      { text: "PRN", value: "prn" },
      { text: "Student", value: "name" },
      { text: "Route Stop", value: "route_stop" },
      { text: "Application Date", value: "application_date"},
      { text: "Distance Slab", value: "distanceslab" },///
      { text: "Fees In Rs", value: "totalfees" },                //learnerTransportFes
      { text: "Paid Till Now", value: "sync_paid_till_now_amount" },
      // { text: "Your Approval Status", value: "your_status" },
      // { text: "Final Approval Status", value: "transportapprovalstatus" },
      { text: "Action", value: "action" },
      // { text: "Unmark", value: "unmark", },
      // { text: "Is Sync", value: "is_transport_sync" },
      // { text: "My Approval Status", value: "history" },
      
    ],
    headers_history: [
      { text: "SR No", value: "count" },
      { text: "Authority", value: "transportapprovalhierarchy" },
      { text: "Authority Level", value: "authority_level" },
      { text: "Is Last Authority", value: "is_last_approval" },
      { text: "Application Date", value: "application_push_date" },
      { text: "Action Date", value: "application_action_date" },
      { text: "Status", value: "transportapprovalstatus" },
      { text: "Remark", value: "remark" },
    ],
    isLastAuthority:false,tranport_fee_sync:false,unmark_tranport_fee_sync:false
  }),
  computed: {
    sortedTransportList() {
      return [...this.learner_transport_fees_installment_details].sort((a, b) => {
        const aApprove = (!a.is_blocked_for_transport && !a.is_transport_sync);
        const bApprove = (!b.is_blocked_for_transport && !b.is_transport_sync);

        return bApprove - aApprove;
      });
    }
  },
  methods: {
    markApprove(item){
      if (!confirm("Are You Sure You Want To Approve Request...?")) return;
      const data = {
        learner_transport_fees_installment: item.id,
        learner_id: item.learner_id, 
        ay:this.ay
      };
      this.overlay = true;
       axios
        .post("/ParentTransport/markTransportRequestApprove", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            // this.learner_transport_fees_installment_details =res.data.learner_transport_fees_installment_details;
            this.fetch()
            this.showSnackbar("green", "Request Is Approved");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getInstallmentData(){
      this.transport_installment_list=[],
      this.all_learner_list=[],
       this.learner_transport_fees_installment_details =[]
       const data = {
        academicYear: this.ay
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getInstallmentDataByAy", data)
        .then((res) => {
          if (res.data.flag == "YES") {
             this.transport_installment_list = res.data.transport_installment_list;
            this.all_learner_list = res.data.all_learner_list;
            if(this.transport_installment_list==''){
                this.showSnackbar("red", "Installment List Not Defined For This Academicyear...");    
                return
            }           
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    setValue(installment_name) {
      // // alert("installment_name::"+installment_name)
      // this.totalfees_approved = this.child_details.totalfees;
      // if (installment_name.name != "Yearly") {
      //   this.totalfees_approved = parseFloat(this.child_details.totalfees / 2);
      // } else {
      //   this.totalfees_approved;
      // }
      // return this.totalfees_approved;
      const data = {
        installment: installment_name,
        learner_transport_fees_installment_id:
          this.learner_transport_fees_installment_id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getInstallmentAmount", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.totalfees_approved = res.data.final_amount;
            //  this.show_fees = true
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getArrovalHistory(item) {
      const data = {
        learnertransportfeesinstallment: item.id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getArrovalHistory", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.transportApprovalDetails = res.data.transportApprovalDetails;
            this.transportApplicationsDetails =
              res.data.transportApplicationsDetails[0];
            this.show_approve_history_card = true;
            // this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    saveApproveStatus() {
      if (!confirm("Are You Sure You Want To Save...?")) return;
      if (this.transportstatus == null || this.transportstatus == "") {
        this.showSnackbar("red", "Please Select Status");
        return;
      }
      const data = {
        learnertransportfeesinstallment: this.learnertransportfeesinstallment,
        transportstatus: this.transportstatus,
        remark: this.approve_remark,
        transportinstallment: this.transportinstallment,
        total_fees: this.totalfees_approved,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/saveApproveStatus", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.show_approve_transport_card = false), this.fetch();
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    editItem(item) {
      this.transportstatus=""
      this.learner_transport_fees_installment_id = item.id;
      const data = {
        learner_transport_fees_installment: item.id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/fetchTransportApplicationsDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", res.data.snackbar);
            this.child_details.registration_number =res.data.registration_number;
            this.child_details.learner = res.data.learner;
            this.child_details.lid = res.data.lid;
            this.child_details.standard = res.data.standard;
            this.child_details.pickup_time = res.data.pickup_time;
            this.child_details.drop_time = res.data.drop_time;
            this.child_details.academicYear = res.data.academicYear;
            this.child_details.contact = res.data.contact;
            this.child_details.resedential_address =res.data.resedential_address;
            this.route_stops = res.data.route_stops;
            this.routes = res.data.routes;
            this.child_details.totalfees = res.data.totalfees;
            this.child_details.applicable_fees = res.data.applicable_fees;
            this.child_details.paid_till_now = res.data.paid_till_now;
            this.child_details.routestop = res.data.routestop;
            this.child_details.route = res.data.route;
            (this.child_details.distanceslab = res.data.distanceslab),
              (this.routestop = res.data.routestop_id);

            this.child_details.routestop_name = res.data.routestop;
            this.child_details.route_name = res.data.route;
            this.child_details.transport_installment_amount =res.data.transport_installment_amount;
            this.child_details.transport_installment =res.data.transport_installment;

            this.route = res.data.route_id;
            this.transport_installment_list =res.data.transport_installment_list;
            this.transport_status_list = res.data.transport_status_list;
            //this.transportinstallment=res.data.transport_installment_id
            this.learnertransportfeesinstallment =res.data.learnertransportfeesinstallment;
            this.is_final_approved=res.data.is_final_approved
            this.show_approve_transport_card = true;
            // this.learner_transport_fees_installment_details=res.data.learner_transport_fees_installment_details
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    fetch() {
     // this.headers_2=[]
      if(this.transport_status==''){
          this.showSnackbar("red","Please Select Status");
            return
      }
       if(this.transport_installment==''){
          this.showSnackbar("red","Please Select Installment");
            return
      }
      if(this.learner==''){
          this.showSnackbar("red","Please Select Students");
          return
      }
      const data = {
        academicYear: this.ay,
        learner: this.learner,
        transport_status: this.transport_status,
        transport_installment: this.transport_installment,
        standard: this.standard,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/fetchTransportApplications", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", res.data.snackbar);
            this.learner_transport_fees_installment_details =
              res.data.learner_transport_fees_installment_details;
              this.isLastAuthority=res.data.isLastAuthority,
              this.tranport_fee_sync=res.data.tranport_fee_sync
              this.unmark_tranport_fee_sync=res.data.unmark_tranport_fee_sync
              //  if(this.unmark_tranport_fee_sync == true) {
              //      this.headers_2.push({ text: "Unmark", value: "unmark" }); 
              //  }
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
     downloadFile() {
      const excelData = this.sortedTransportList.map((item, index) => {
        let actionText = "";
        if (!item.is_blocked_for_transport && !item.is_transport_sync) {
          actionText = "Approved";
        } else if (item.is_transport_sync) {
          actionText = "Already Synched...";
        } else {
          actionText = "Student Is Blocked For Transport...";
        }

        return {
          "S.No": index + 1,
          "PRN": item.prn,
          "Name": item.name,
          "Route Stop": item.route_stop,
          "Application Date": item.application_date,
          "Distance Slab": item.distanceslab,
          "Fees In Rs": item.totalfees,
          "Paid Till Now": item.sync_paid_till_now_amount,
          "Action": actionText,
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "TransporterApprove");
      XLSX.writeFile(workbook, "TransporterApprove.xlsx");
    },

    onLoad() {
      axios
        .post("ParentTransport/approveTransportApplication")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.standard_list = res.data.standard_list;
            this.transport_status_list = res.data.transport_status_list;
            this.transport_installment_list =
              res.data.transport_installment_list;
            this.all_learner_list = res.data.all_learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>